import { Label, TextInput } from "flowbite-react";
import { UseFormRegisterReturn } from "react-hook-form";

interface ModalFormReadOnlyTextInputProps {
    register: UseFormRegisterReturn,
    fieldName: string,
    label: string,
    placeholder: string
}

const ModalFormReadOnlyTextInput = ({register, fieldName, label, placeholder}: ModalFormReadOnlyTextInputProps) => {
    return (
        <div>
            <div className='col-span-3'>
                <div className="mb-2 block">
                    <Label htmlFor={fieldName} value={label} />
                </div>
                <TextInput
                    readOnly
                    id={fieldName}
                    placeholder={placeholder}
                    {...register}
                />
            </div>
        </div>
    )
}

export default ModalFormReadOnlyTextInput;